import { sortBy } from 'lodash';

import 'regenerator-runtime/runtime';
import { vsosHttp as http } from 'lib/services/http';

import { LocationSchema } from './schemas';

const validateHandler = (schema, object, apiCall) => {
  return schema.validate(object).then(() => {
    return apiCall();
  });
};

const deleteLocation = (locationId) => {
  return http.delete(`locations/${locationId}`);
};

const getAvailableLocationPhoneNumbers = ({ locationId = '' }) => {
  return http.get(`users/${locationId}/phone-numbers`);
};

const getTimezones = () => {
  return http.get('/locations/timezones');
};

const getStates = async (countryCode = 'ALL') => {
  const response = await http.get(`/locations/countries/${countryCode}/states`);

  return sortBy(
    response.map((state) => ({
      value: state.stateCode,
      label: `${state.stateCode} - ${state.stateName}`,
      key: state.stateCode,
      id: state.stateCode,
    })),
  );
};

const postIsEmergencyAddressValid = (locationObj = {}) => {
  return http.post('/locations/emergency-address/valid', locationObj);
};

const locationTypes = [
  { value: 'APT', label: 'Apartment' },
  { value: 'BSMT', label: 'Basement' },
  { value: 'BLDG', label: 'Building' },
  { value: 'DEPT', label: 'Department' },
  { value: 'FL', label: 'Floor' },
  { value: 'FRNT', label: 'Front' },
  { value: 'HNGR', label: 'Hangar' },
  { value: 'KEY', label: 'Key' },
  { value: 'LBBY', label: 'Lobby' },
  { value: 'LOT', label: 'Lot' },
  { value: 'LOWR', label: 'Lower' },
  { value: 'OFC', label: 'Office' },
  { value: 'PH', label: 'Penthouse' },
  { value: 'PIER', label: 'Pier' },
  { value: 'REAR', label: 'Rear' },
  { value: 'RM', label: 'Room' },
  { value: 'SIDE', label: 'Side' },
  { value: 'SLIP', label: 'Slip' },
  { value: 'SPC', label: 'Space' },
  { value: 'STOP', label: 'Stop' },
  { value: 'STE', label: 'Suite' },
  { value: 'TRLR', label: 'Trailer' },
  { value: 'UNIT', label: 'Unit' },
  { value: 'UPPR', label: 'Upper' },
];

const getLocationTypes = async () => {
  return Promise.resolve(
    sortBy(
      locationTypes.map((locationType) => {
        locationType.key = locationType.value;
        locationType.id = locationType.value;

        return locationType;
      }),
      [(tz) => tz.label],
    ),
  );
};

export const createLocation = (location) => {
  const path = `/locations`;
  const apiCall = () => {
    return http.post(path, location);
  };

  return validateHandler(LocationSchema.Save, location, apiCall);
};

export const updateLocation = (location) => {
  return LocationSchema.Save.validate(location).then(() => {
    return http.put(`/locations/${location.locationId}`, location);
  });
};

export const getLocations = () => {
  return http.get('locations');
};

export const getLocationCount = () => {
  return http.get('locations/count');
};

export const getLocationAdmin = (locationId) => {
  return http.get(`locations/${locationId}/admins`);
};

export default {
  createLocation,
  deleteLocation,
  getTimezones,
  getStates,
  getLocationTypes,
  getAvailableLocationPhoneNumbers,
  getLocations,
  postIsEmergencyAddressValid,
  updateLocation,
  getLocationCount,
  getLocationAdmin,
};
